import { authenticatedGet, authenticatedPost, authenticatedPut, authenticatedDelete } from "../../api/authenticatedFetch";

const BASE = "/api/v1/taxonomy";

export const getCategories = async () => authenticatedGet(`${BASE}/categories`);
export const getSourceTypes = async () => authenticatedGet(`${BASE}/source-types`);
export const createCustomSourceType = async (payload) => authenticatedPost(`${BASE}/source-types`, payload);
export const updateCustomSourceType = async (id, payload) => authenticatedPut(`${BASE}/source-types/${id}`, payload);
export const deleteCustomSourceType = async (id) => authenticatedDelete(`${BASE}/source-types/${id}`);
